export enum CustomerType {
  PRIVATE = 'particulier',
  COMPANY = 'bedrijf',
}
